import React, {PropTypes} from 'react';
import {Button} from '@goguardian/based';
import ProgressSteps from '../progress';
import Loading from '_shared/components/loading';

import style from './style.scss';

class SurveyEnd extends React.Component {

  render() {
    return (
      <div>
        <ProgressSteps
          steps={['Sign Up', 'Quick Questions', 'Get Started']}
          current={3} />
        <div className={style.surveyContainer}>
          <div className={style.icon}></div>
          <Loading className={style.loadingContainer}
            minDisplayTime={5000}
            actionName="submitSurvey"
            header="Thank you! Now, let’s get you started…"
            >
            YOU’LL BE REDIRECTED IN A FEW SECONDS
          </Loading>
        </div>
      </div>
    );
  }
};

export default SurveyEnd;



/** WEBPACK FOOTER **
 ** ./src/app/components/survey/end/index.jsx
 **/